import { classNames } from 'libs/react';
import { useRef } from 'libs/react';
import { Reveal } from './private/Reveal';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { React } from 'libs/react';
import './FormSection.scss';
/**
 * @component FormSection
 * @since 1.0.0
 */
export function FormSection(props) {
    const { style, title, infos, enter, leave, button } = Object.assign({ style: 'normal' }, props);
    const node = useRef(null);
    /*
    const [bounds] = useMeasure(node);
  
    useEffect(() => {
      if (node.current) {
        node.current.style.setProperty(
          '--scroll-width',
          node.current.scrollWidth + 'px'
        );
        node.current.style.setProperty(
          '--scroll-height',
          node.current.scrollHeight + 'px'
        );
      }
    }, [bounds.width, bounds.height]);
    */
    const className = classNames('form-section', 'form-section--' + style, props.className);
    return (React.createElement(Reveal, { enter: enter, leave: leave, presentClassName: "form-section--present", dismissClassName: "form-section--dismiss" },
        React.createElement("div", { ref: node, className: className },
            React.createElement("div", { className: "form-section-head" },
                React.createElement(Case, { is: title || infos },
                    React.createElement("div", { className: "form-section-heading" },
                        title && (React.createElement(Text, { className: "form-section-title", value: title, style: style })),
                        infos && (React.createElement(Text, { className: "form-section-infos", value: infos, style: style })))),
                React.createElement(Case, { is: button },
                    React.createElement("div", { className: "form-section-actions" }, button))),
            React.createElement("div", { className: "form-section-body" }, props.children))));
}
